import { defineMessages } from 'react-intl';

export const NotFound = defineMessages({
  headerContent: {
    id: 'app.NotFound.headerContent',
    defaultMessage: 'Stránka nenalezena',
  },
  contentText: {
    id: 'app.NotFound.contentText',
    defaultMessage: ' Smutné zprávy, stranka neexistuje a nebo není dočasně k dispozici.',
  },
  contentSubText: {
    id: 'app.NotFound.contentSubText',
    defaultMessage: ' Zkus obnovit stránku, popřípadě se vrať zpátky.',
  },
  goBack: {
    id: 'app.NotFound.goBack',
    defaultMessage: 'Jít zpět',
  },
});
